import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoaderContext from "../../components/loader";
import BreadCrumb from "../../components/BreadCrumb";
import BasicTable from "../../components/Table/BasicTable";
import PaymentEarning from "../../components/DashboardComponents/Earning/PaymentEarning";
import styles from "./dashboard.module.css";
import Card from "../../components/DashboardComponents/Card/Card";
import { FaBoxes, FaRegUser } from "react-icons/fa";
import { LuBoxes } from "react-icons/lu";
import { GrUndo, GrUserManager } from "react-icons/gr";
import { CgArrowsExchange } from "react-icons/cg";
import {
  MdOutlineProductionQuantityLimits,
  MdOutlineStorefront,
} from "react-icons/md";
import { LiaCitySolid } from "react-icons/lia";
import { IoBasketOutline } from "react-icons/io5";
import { GiStorkDelivery } from "react-icons/gi";
import { MdOutlineCancel } from "react-icons/md";
import { FaRegCircleCheck, FaShopSlash, FaUserXmark } from "react-icons/fa6";
import { BiSolidPurchaseTag } from "react-icons/bi";
import { FaHandHoldingUsd } from "react-icons/fa";
import { FaWallet } from "react-icons/fa";
import { FaCoins } from "react-icons/fa6";
import { BsBoxes, BsCashCoin } from "react-icons/bs";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import BarChart from "../../components/DashboardComponents/BarChart/BarChart";
import LineChart from "../../components/DashboardComponents/Linechart/LineChart";
import PieChart from "../../components/DashboardComponents/PiChart/PieChart";
import MonthBarChart from "../../components/DashboardComponents/BarChart/MonthBarChart";
import OrderComp from "../Order/OrderComp";
import { useFetchAll } from "../../custom/FetchApiHook";
import { dashboardApis } from "../../apis/dashboard.apis";
import { TbReplaceFilled, TbSum, TbTruckReturn } from "react-icons/tb";
import CardKPI from "../../components/DashboardComponents/Card/CardKPI";
import SmallCardKPI from "../../components/DashboardComponents/Card/SmallCardKPI";
import { CiDeliveryTruck } from "react-icons/ci";
import { formattedAmount } from "../../utils/helpers/Functions.helper";
import EarninChart from "../../components/DashboardComponents/BarChart/EarningChart";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
function Dashboard() {
  const { theme } = useSelector((state) => state.theme);

  const orderAnalytics = useFetchAll(() =>
    dashboardApis.getOrderAnalytics(
      dashboardPagination ? dashboardPagination : {}
    )
  );

  const [dashboardPagination, setDashboardPagination] = useState({
    filter: {},
  });

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const [productDetailCounts, setProductDetailCounts] = useState([
    {
      heading: "Product Details",
      contents: [
        {
          Icon: MdOutlineProductionQuantityLimits,
          label: "Total products",
          count: null,
        },
        {
          Icon: FaBoxes,
          label: "Total categories",
          count: null,
        },
        {
          Icon: LuBoxes,
          label: "Total subcategories",
          count: null,
        },
        // {
        //   Icon: LiaCitySolid,
        //   label: "City",
        //   count:null,
        // },
      ],
    },
    {
      heading: "Ordered",
      contents: [
        {
          Icon: IoBasketOutline,
          label: "All",
          count: null,
        },
        {
          Icon: GiStorkDelivery,
          label: "Deliveries",
          count: null,
        },
        {
          Icon: BiSolidPurchaseTag,
          label: "Total Item Sold",
          count: null,
        },
        {
          Icon: MdOutlineCancel,
          label: "Store Cancelled",
          count: null,
        },
        {
          Icon: FaRegCircleCheck,
          label: "Completed",
          count: null,
        },
      ],
    },
    {
      heading: "Payment Details",
      contents: [
        {
          Icon: FaHandHoldingUsd,
          label: "Total",
          count: null,
        },
        {
          Icon: FaWallet,
          label: "Wallet",
          count: null,
        },
        {
          Icon: FaCoins,
          label: "Promo",
          count: null,
        },
        {
          Icon: BsCashCoin,
          label: "Cash",
          count: null,
        },
        {
          Icon: RiMoneyDollarCircleFill,
          label: "Other",
          count: null,
        },
      ],
    },
  ]);

  const [monthViewPagination, setMonthViewPagination] = useState({
    filter: {},
  });

  const { value: earningData, fetchAllData: getEarningData } = useFetchAll(() =>
    dashboardApis.getEarningAnalytics(pagination ? pagination : {})
  );
  const { value: earningMonth, fetchAllData: getEarningMonth } = useFetchAll(
    () =>
      dashboardApis.getEarningAnalytics(
        monthViewPagination ? monthViewPagination : {}
      )
  );

  const earningKpis = earningData?.data?.dailyBreakdownSum;

  // const handlePagination = (data) => {
  //   console.log("data", data);
  //   if (data.clearPagination) {
  //     setPagination(data.clearPagination);
  //     return;
  //   }

  //   setPagination((prev) => {
  //     let copyPagination = { ...prev.filter };

  //     if (data.filter) {
  //       copyPagination = { ...data?.filter, ...copyPagination };
  //     }

  //     return {
  //       page: data.page ? data.page : 1,
  //       limit: data.limit ? data.limit : 5,
  //       sortOrder: data.sortOrder ? data.sortOrder : "desc",
  //       filter: copyPagination,
  //     };
  //   });
  // };

  const handleFilter = (filter, value) => {
    console.log("filter", filter);
    console.log("value", value);
    if (value) {
      setPagination({
        filter: {
          startDate: value[0],
          endDate: value[1],
          // "startDate":moment(value[0]).format("DD-MM-YYYY") ,
          // "endDate":moment(value[1]).format("DD-MM-YYYY")
        },
        view: filter || "day",
      });
    }
  };

  const handleFilterMonthView = (filter, value) => {
    console.log("filter", filter);
    console.log("value", value);
    if (value) {
      setMonthViewPagination({
        filter: {
          startDate: value[0],
          endDate: value[1],
          // "startDate":moment(value[0]).format("DD-MM-YYYY") ,
          // "endDate":moment(value[1]).format("DD-MM-YYYY")
        },
        view: filter || "day",
      });
    }
  };

  // const progressData = [
  //   // {
  //   //   left: {
  //   //     progress: 10,
  //   //     label: "Total",
  //   //     price: "₹ 1414.82",
  //   //   },
  //   //   right: {
  //   //     progress: 60,
  //   //     label: "Admin Earnings",
  //   //     price: "₹ 17.19",
  //   //   },
  //   // },
  //   {
  //     left: {
  //       progress: 20,
  //       label: "Order Payment",
  //       price: "₹ 1243.00",
  //     },
  //     right: {
  //       progress: 50,
  //       label: "Store Earning",
  //       price: "₹ 1243.00",
  //     },
  //   },
  //   {
  //     left: {
  //       progress: 20,
  //       label: "Delivery Payment",
  //       price: "₹ 171.82",
  //     },
  //     right: {
  //       progress: 50,
  //       label: "Delivery Man Earnings",
  //       price: "₹ 154.63",
  //     },
  //   },
  // ];
  // const progressData = [
  //   {
  //     left: {
  //       progress: parseFloat(
  //         (+earningKpis?.totalOrderPayment * 100) /
  //           +earningKpis?.totalOrderPayment || 0
  //       ).toFixed(2),
  //       label: "Total",
  //       price: formattedAmount(earningKpis?.totalOrderPayment), //"₹ 1414.82"
  //     },
  //     right: {
  //       progress: parseFloat(
  //         (+earningKpis?.adminEarn * 100) / +earningKpis?.totalOrderPayment || 0
  //       ).toFixed(2),
  //       label: "Admin Earnings",
  //       price: formattedAmount(earningKpis?.adminEarn), //"₹ 17.19"
  //     },
  //   },
  //   {
  //     left: {
  //       progress: parseFloat(
  //         (+earningKpis?.totalOrderPayment * 100) /
  //           +earningKpis?.totalOrderPayment || 0
  //       ).toFixed(2),
  //       label: "Order Payment",
  //       price: formattedAmount(earningKpis?.totalOrderPayment), //"₹ 1243.00"
  //     },
  //     right: {
  //       progress: parseFloat(
  //         (+earningKpis?.storeEarn * 100) / +earningKpis?.totalOrderPayment || 0
  //       ).toFixed(2),
  //       label: "Store Earning",
  //       price: formattedAmount(earningKpis?.storeEarn), // "₹ 1243.00"
  //     },
  //   },
  //   // {
  //   //   left: {
  //   //     progress: parseFloat(
  //   //       (+earningKpis?.totalDeliveryPayment * 100) /
  //   //         +earningKpis?.totalDeliveryPayment || 0
  //   //     ).toFixed(2),
  //   //     label: "Delivery Payment",
  //   //     price: formattedAmount(earningKpis?.totalDeliveryPayment), //"₹ 171.82"
  //   //   },
  //   //   right: {
  //   //     progress: parseFloat(
  //   //       (+earningKpis?.deliverymanEarn * 100) /
  //   //         +earningKpis?.totalDeliveryPayment || 0
  //   //     ).toFixed(2),
  //   //     label: "Deliveryman Earnings",
  //   //     price: formattedAmount(earningKpis?.deliverymanEarn), // "₹ 154.63"
  //   //   },
  //   // },
  // ];

  const progressData = [
  {
    left: {
      progress: earningKpis?.totalOrderPayment
        ? parseFloat(
            (+earningKpis?.totalOrderPayment * 100) /
              +earningKpis?.totalOrderPayment
          ).toFixed(2)
        : "0",
      label: "Total",
      price: formattedAmount(earningKpis?.totalOrderPayment),
    },
    right: {
      progress: earningKpis?.totalOrderPayment
        ? parseFloat(
            (+earningKpis?.adminEarn * 100) / +earningKpis?.totalOrderPayment
          ).toFixed(2)
        : "0",
      label: "Admin Earnings",
      price: formattedAmount(earningKpis?.adminEarn),
    },
  },
  {
    left: {
      progress: earningKpis?.totalOrderPayment
        ? parseFloat(
            (+earningKpis?.totalOrderPayment * 100) /
              +earningKpis?.totalOrderPayment
          ).toFixed(2)
        : "0",
      label: "Order Payment",
      price: formattedAmount(earningKpis?.totalOrderPayment),
    },
    right: {
      progress: earningKpis?.totalOrderPayment
        ? parseFloat(
            (+earningKpis?.storeEarn * 100) / +earningKpis?.totalOrderPayment
          ).toFixed(2)
        : "0",
      label: "Store Earning",
      price: formattedAmount(earningKpis?.storeEarn),
    },
  },
];

  const getAllDashboardCount = async () => {
    try {
      const res = await dashboardApis.getDashboardCounts();
      console.log("res::count", res.data.data);
      const dashboardCounts = res.data.data;

      setProductDetailCounts([
        {
          heading: "Product Details",
          contents: [
            {
              Icon: MdOutlineProductionQuantityLimits,
              label: "Total products",
              count: dashboardCounts?.totalProduct || null,
            },
            {
              Icon: FaBoxes,
              label: "Total categories",
              count: dashboardCounts?.totalCategory || null,
            },
            {
              Icon: LuBoxes,
              label: "Total subcategories",
              count: dashboardCounts?.totalSubCategory || null,
            },
            // {
            //   Icon: LiaCitySolid,
            //   label: "City",
            //   count:null,
            // },
          ],
        },
        {
          heading: "Ordered",
          contents: [
            {
              Icon: TbSum,
              label: "All",
              count: dashboardCounts?.totalOrders || 0,
            },
            {
              Icon: CiDeliveryTruck,
              label: "Delivered",
              count: dashboardCounts?.deliveredOrders || 0,
            },
            {
              Icon: FaUserXmark,
              label: "Customer Cancelled",
              count: dashboardCounts?.userCancelledOrders || 0,
            },
            {
              Icon: FaShopSlash,
              label: "Store Cancelled",
              count: dashboardCounts?.storeCancelledOrders || 0,
            },
            {
              Icon: GrUndo,
              label: "Returned",
              count: dashboardCounts?.returnedOrders || 0,
            },
            {
              Icon: CgArrowsExchange,
              label: "Replacement",
              count: dashboardCounts?.replacementOrders || 0,
            },
          ],
        },
        // {
        //   heading: "Payment Details",
        //   contents: [
        //     {
        //       Icon: FaHandHoldingUsd,
        //       label: "Total",
        //       count: null,
        //     },
        //     {
        //       Icon: FaWallet,
        //       label: "Wallet",
        //       count: null,
        //     },
        //     {
        //       Icon: FaCoins,
        //       label: "Promo",
        //       count: null,
        //     },
        //     {
        //       Icon: BsCashCoin,
        //       label: "Cash",
        //       count: null,
        //     },
        //     {
        //       Icon: RiMoneyDollarCircleFill,
        //       label: "Other",
        //       count: null,
        //     },
        //   ],
        // },
      ]);
    } catch (error) {}
  };
  useEffect(() => {
    getEarningData();
  }, [pagination]);

  useEffect(() => {
    getEarningMonth();
  }, [monthViewPagination]);

  useEffect(() => {
    getAllDashboardCount();
  }, []);

  useEffect(() => {
    orderAnalytics.fetchAllData();
  }, [dashboardPagination]);

  console.log("progressData",progressData)

  return (
    <div className="main-content mr-2">
      <BreadCrumb title={"Dashboard"} />
      {/* <OrderComp pagination={pagination} handlePagination={handlePagination} /> */}

      <div
        className={`d-flex flex-column gap-1  mt-5 ${
          theme === "light"
            ? "bg-secondaryColor text-primaryColor"
            : "bg-darkThirsary text-darkSecondary"
        } `}
      >
        <div className={`${styles.dashboardProgress}  `}>
          {/* {productDetailCounts.length
            ? productDetailCounts.map((data, i) => <Card key={i} data={data} />)
            : ""} */}
          <CardKPI data={productDetailCounts[0]} />
          <SmallCardKPI data={productDetailCounts[1]} />
        </div>

        {/* <div
          className={`${styles.dashboardProgress} ${
            theme === "light" ? styles.bgSecondaryColor : styles.bgDarkThirsary
          }`}
        >
          {progressData.map(({ left, right }, i) => (
            <PaymentEarning key={i} left={left} right={right} />
          ))}
        </div> */}
        <BarChart
          data={orderAnalytics?.value?.data}
          handleFilter={handleFilter}
        />
        <div className="pl-5 pt-5 pr-1">
          <LineChart
            data={earningMonth?.data?.monthlyBreakdown}
            filters={{ range: false, view: "year" }}
            handleFilter={handleFilterMonthView}
          />
          <EarninChart
            progressData={progressData}
            data={earningData?.data?.dailyBreakdown}
            handleFilter={handleFilter}
          />
        </div>
        {/* <div className="d-flex gap-2">
          <PieChart />
          <MonthBarChart />
        </div> */}
      </div>
    </div>
  );
}

export default Dashboard;
